import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetch_commission_coverage,
  fetch_commission_rules,
  fetch_service_commission_rules,
  set_commission_rule,
  set_service_commission_rule,
} from './api';
import type { SetRuleInput, SetServiceRuleInput, Vertical } from './types';
import { fetch_adoption_fee, set_adoption_fee } from './api';

const GOODS_KEY = 'admin-commission-rules';
const SERVICE_KEY = 'admin-service-commission-rules';
const COVERAGE_KEY = 'admin-commission-coverage';

export function use_commission_coverage() {
  return useQuery({ queryKey: [COVERAGE_KEY], queryFn: fetch_commission_coverage });
}

export function use_commission_rules(vertical?: Vertical) {
  return useQuery({
    queryKey: [GOODS_KEY, vertical ?? 'all'],
    queryFn: () => fetch_commission_rules(vertical),
    placeholderData: (prev) => prev,
  });
}

export function use_set_commission_rule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: SetRuleInput) => set_commission_rule(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [GOODS_KEY] });
      qc.invalidateQueries({ queryKey: [COVERAGE_KEY] });
    },
  });
}

export function use_service_commission_rules() {
  return useQuery({
    queryKey: [SERVICE_KEY],
    queryFn: fetch_service_commission_rules,
    placeholderData: (prev) => prev,
  });
}

export function use_set_service_commission_rule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: SetServiceRuleInput) => set_service_commission_rule(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [SERVICE_KEY] });
      qc.invalidateQueries({ queryKey: [COVERAGE_KEY] });
    },
  });
}

const ADOPTION_FEE_KEY = ['admin', 'commission', 'adoption-fee'] as const;

export function use_adoption_fee() {
  return useQuery({ queryKey: ADOPTION_FEE_KEY, queryFn: fetch_adoption_fee });
}

export function use_set_adoption_fee() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (amount_inr: number) => set_adoption_fee(amount_inr),
    onSuccess: () => qc.invalidateQueries({ queryKey: ADOPTION_FEE_KEY }),
  });
}
